import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Snackbar from "@material-ui/core/Snackbar";

import HomeIcon from "@material-ui/icons/Home";
import MapIcon from "@material-ui/icons/Map";

import Header from "../../components/Header/Header.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import NavPills from "../../components/NavPills/NavPills.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import Clearfix from "../../components/Clearfix/Clearfix.jsx";

import SectionTable from "./SectionTable";
import SectionBlockedDates from "./SectionBlockedDates";
import CustomNotification from "../LandingPage/Sections/CustomNotification";

import profilePhoto from "../../assets/img/faces/default-profile.jpg";

import profilePageStyle from "../../assets/jss/material-kit-pro-react/views/profilePageStyle.jsx";

import { getOwnerServices } from '../../actions/ownersActions';

import translateRole from "../../utils/translateRole";

class ManageServices extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: '',
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        const { user } = this.props.authReducer;
        if (user.role !== 'Owner' && user.role !== 'Administrator') {
            this.props.history.push({ pathname: '/profile', state: { message: 'No tienes permiso para acceder al módulo', type: 'warning' } });
        } else {
            this.props.getOwnerServices(user._id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        } else if (nextProps.ownersReducer.bookResponse !== '') {
            this.handleClickNotification(nextProps.ownersReducer.bookResponse, 'success');
        } else if (nextProps.ownersReducer.serverResponse !== '') {
            this.handleClickNotification(nextProps.ownersReducer.serverResponse, 'success');
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    render() {
        const { classes, authReducer, ownersReducer,
            // ...rest
        } = this.props;
        const { user } = authReducer;

        // const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Gestionar mis servicios | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/profile" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info" />}
                    changeColorOnScroll={{
                        height: 200,
                        color: "white"
                    }}
                />
                <Parallax
                    image={require("../../assets/img/landing-bg.jpg")}
                    filter="dark"
                    className={classes.parallax}
                />
                <div className={classNames(classes.main, classes.mainRaised)}>
                    {/* Custom Notification */}
                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                    </Snackbar>
                    {/* End Custom Notification */}

                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <div className={classes.profile}>
                                    <div>

                                        <img src={profilePhoto} alt="Foto de perfil" title="Foto de perfil" className={classNames(classes.imgRaised, classes.imgRoundedCircle, classes.imgFluid)} />

                                    </div>
                                    <div className={classes.name}>

                                        <h3 className={classes.title}>{user.first_name} {user.last_name}</h3>
                                        <h4><strong>({user.username})</strong></h4>
                                        <h5>{translateRole(user.role)}</h5>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>

                        <div className={classNames(classes.description, classes.textCenter)}>
                            <p>Consulta y administra los servicios turísticos asociados a tu cuenta, añadiendo fechas de no-disponibilidad en cada uno de ellos.</p>
                        </div>

                        <div className={classes.profileTabs}>
                            <NavPills
                                alignCenter
                                color="success"
                                tabs={[
                                    {
                                        tabButton: "Alojamientos",
                                        tabIcon: HomeIcon,
                                        tabContent: (
                                            <SectionTable serviceType={'accommodations'} tableContent={ownersReducer.accommodations} />
                                        )
                                    },{
                                        tabButton: "Tours",
                                        tabIcon: MapIcon,
                                        tabContent: (
                                            <SectionTable serviceType={'tours'} tableContent={ownersReducer.tours} />
                                        )
                                    }
                                ]}
                            />
                        </div>
                        <Clearfix />

                        {ownersReducer.blockedDates.length > 0
                            ? <SectionBlockedDates blockedDates={ownersReducer.blockedDates} />
                            : null
                        }
                    </div>
                </div>

                <Footer
                    className={classes.footer}
                    content={
                        <div>
                            <div className={classes.left}>
                                <List className={classes.list}>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/" className={classes.block}> Inicio </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/accommodations" className={classes.block}> Alojamientos </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/tours" className={classes.block}> Tours </Link>
                                    </ListItem>
                                    <ListItem className={classes.inlineBlock}>
                                        <Link to="/contacto" className={classes.block}> Contacto </Link>
                                    </ListItem>
                                </List>
                            </div>

                            <div className={classes.right}> &copy; {1900 + new Date().getYear()} Vivamos el Campo. Todos los derechos reservados.</div>
                        </div>
                    }
                />
            </div>
        );
    }
}

ManageServices.propTypes = {
    getOwnerServices: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    ownersReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    ownersReducer: state.ownersReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { getOwnerServices })( withStyles(profilePageStyle)(ManageServices) );



// WEBPACK FOOTER //
// ./src/views/Management/ManageServices.jsx